<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12" v-if="miscCreateObj.claim_number">
                <div class="d-flex headerOrderDetail">
                  <div class="orderNumber">
                    <h1 class="mt-20 pl-20">{{miscCreateObj.claim_number}}</h1>
                    <h4 class="c-orange mb-0 caseStatus text-uppercase">{{miscCreateObj.status}}</h4>
                  </div>
                </div>
            </b-col>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :variableWidth="true"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                                class="mr-3"
                                :disabled="!!miscExpenseItem.payment_voucher || miscExpenseItem.status === 'Cancelled' || $route.params.id === '0'"
                                @click="cancelMiscExpense"
                                label="Cancel" :outline="!miscExpenseItem.payment_voucher && miscExpenseItem.status !== 'Cancelled' && $route.params.id !== '0'"></gofix-button>
                        <gofix-button
                                class="mr-3"
                                v-if="$route.params.id !== '0'"
                                :disabled="!!miscExpenseItem.payment_voucher || miscExpenseItem.status !== 'Draft' || isAction"
                                @click="save(1)"
                                label="Submit & Raise PV"></gofix-button>
                        <gofix-button
                                class="mr-3"
                                v-if="$route.params.id === '0'"
                                @click="save(1)"
                                :disabled="isAction"
                                label="Submit & Raise PV"></gofix-button>
                        <gofix-button
                                class="mr-3"
                                :disabled="!!miscExpenseItem.payment_voucher || miscExpenseItem.status === 'Cancelled' || (miscExpenseItem.length > 0 && miscExpenseItem.status !== 'Draft') || isAction || miscExpenseItem.status === 'Submitted'"
                                @click="save(0)"
                                label="Submit"></gofix-button>
                        <gofix-button
                                @click="save(2)"
                                :disabled="(miscExpenseItem.status === 'Cancelled' && $route.params.id !== '0' )|| miscExpenseItem.status === 'PV Under Approval' ||  disableButtonSave() || isAction || miscExpenseItem.status === 'Submitted'"
                                label="Save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form v-bind:class="{'run-loading':Loadings.detail}">
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Client contract"
                                                v-model="miscCreateObj.contract"
                                                :options="optionsContract"
                                                @search="searchContract"
                                                :filterable="false"
                                                vLabel="contract_name">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="2">
                                    </b-col>
                                    <b-col md="6">
                                        <b-row>
                                            <b-col md="8">
                                                <gofix-text-field label="Created By:"  oneline>{{ $route.params.id === '0' ? UserLogin.name : (miscCreateObj.created_by_name ? miscCreateObj.created_by_name : null) }}</gofix-text-field>
                                            </b-col>
                                            <b-col md="4" class="pd-0">
                                                <gofix-text-field label="Created On:"  oneline>{{timeCurrent}}</gofix-text-field>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input-date
                                                v-model="miscCreateObj.claim_date"
                                                label="Expense Claim Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Expense Transaction Type"
                                                v-model="miscCreateObj.claim_transaction_type"
                                                :options="optionsTransaction">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-properties
                                                label="Property"
                                                :contract-id="(miscCreateObj && miscCreateObj.contract) ? miscCreateObj.contract.id : null"
                                                valueFormat="object"
                                                v-model="miscCreateObj.property">
                                        </gofix-form-properties>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                                v-model="miscCreateObj.issue_date_budget"
                                                label="Date Issued Budget"
                                                popover-align="right">
                                        </gofix-form-input-date>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <b-row class="align-items-center">
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                        label="Payment Type"
                                                        v-model="miscCreateObj.payment_method"
                                                        vLabel="reference_value_text"
                                                        :options="optionsPayment">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="6"><!--
                                                <template>
                                                    <div>
                                                        <label class="float-unset display-inline-block">Department</label>
                                                        <div class="info-right">{{ miscCreateObj.department ? miscCreateObj.department : '--' }}</div>
                                                    </div>
                                                </template> -->
                                                <template v-if="miscCreateObj.claim_transaction_type == 'Budgeted'">
                                                    <gofix-text-field label="Department"  oneline>
                                                      {{ miscCreateObj.department && miscCreateObj.department.source_code ? miscCreateObj.department.source_code : '--' }}
                                                    </gofix-text-field>
                                                </template>
                                                <template v-else>
                                                    <div class="property-dropdown dropdown-custom-tooltip">
                                                        <gofix-form-dropdown
                                                                label="Department"
                                                                v-model="miscCreateObj.department"
                                                                vLabel="source_code"
                                                                :options="optionsDepartment"
                                                                @search="searchDepartmentCode"
                                                                :filterable="false">
                                                          <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                            <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                                          </template>
                                                            <template #gofixInput:dropdown:option="option">
                                                                 <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                                            </template>
                                                        </gofix-form-dropdown>
                                                    </div>
                                                </template>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col md="4">
                                        <b-row class="align-items-center">
                                            <b-col md="12" v-if="miscCreateObj.claim_transaction_type == 'Budgeted'">
                                                <div class="pr-5 position-relative">
                                                    <gofix-form-dropdown
                                                            label="FM Code"
                                                            v-model="miscCreateObj.fm_code"
                                                            :options="optionsFMCode"
                                                            @search="searchFMCode"
                                                            :filterable="false"
                                                            @input="showGLCode"
                                                            vLabel="fm_code">
                                                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                            <div class="flex">
                                                                <div class="">
                                                                    <span>{{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code}}</span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template #gofixInput:dropdown:option="option">
                                                            {{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code }}
                                                        </template>
                                                    </gofix-form-dropdown>
                                                    <svg class="custom-field-fmCode-icon" width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.5 0.5C5.6075 0.5 0 6.1075 0 13C0 19.8925 5.6075 25.5 12.5 25.5C19.3925 25.5 25 19.8925 25 13C25 6.1075 19.3925 0.5 12.5 0.5ZM13.75 19.1438V20.5H11.25V19.15C8.32625 18.6913 7.5 16.6475 7.5 15.5H10C10.0138 15.6788 10.1988 16.75 12.5 16.75C14.225 16.75 15 16.0188 15 15.5C15 15.095 15 14.25 12.5 14.25C8.15 14.25 7.5 11.9 7.5 10.5C7.5 8.89 8.78625 7.27 11.25 6.85625V5.515H13.75V6.90125C15.9175 7.41375 16.75 9.2175 16.75 10.5H15.5L14.25 10.5225C14.2325 10.0475 13.9813 9.25 12.5 9.25C10.8763 9.25 10 9.895 10 10.5C10 10.9675 10 11.75 12.5 11.75C16.85 11.75 17.5 14.1 17.5 15.5C17.5 17.11 16.2138 18.73 13.75 19.1438Z" fill="#F05600"/>
                                                    </svg>
                                                </div>
                                            </b-col>
                                            <b-col md="12" v-if="miscCreateObj.claim_transaction_type == 'Non-Budgeted'">
                                                <gofix-form-dropdown
                                                        label="GL Code"
                                                        :options="COA"
                                                        v-model="miscCreateObj.gl_code"
                                                        vLabel="name"
                                                        :filterable="false"
                                                        @search="searchCOA">
                                                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                        <div class="flex">
                                                            <div class="">
                                                                <span>{{option.gl_code + " " + option.name }}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                        {{ option.gl_code + " " + option.name }}
                                                    </template>
                                                </gofix-form-dropdown>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col md="4" align-self="center">
                                        <gofix-text-field v-if="miscCreateObj.claim_transaction_type == 'Budgeted'" label="GL Code"  oneline>{{ miscCreateObj.fm_code && miscCreateObj.fm_code.gl_code ? miscCreateObj.fm_code.gl_code : '--' }}</gofix-text-field>
                                        <gofix-text-field v-else label="Description"  oneline>{{ miscCreateObj.gl_code && miscCreateObj.gl_code.name ? miscCreateObj.gl_code.name : '--' }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row v-if="miscCreateObj.claim_transaction_type == 'Budgeted'">
                                    <b-col md="4">
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field label="FM Description"  oneline>{{ miscCreateObj.fm_code && miscCreateObj.fm_code.description ? miscCreateObj.fm_code.description : '--' }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field label="GL Description"  oneline>{{ miscCreateObj.fm_code && miscCreateObj.fm_code.chart_of_account && miscCreateObj.fm_code.chart_of_account.name ? miscCreateObj.fm_code.chart_of_account.name : '--' }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card title="Pay to">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Pay To Type"
                                                :disabled="$route.params.id != 0 ? true : false"
                                                v-model="miscCreateObj.payee_type"
                                                :options="payee_type_option"
                                                :filterable="false"
                                                :clearable="false"
                                                vLabel="name">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <template v-if="miscCreateObj.payee_type == 'Supplier'">
                                        <b-col md="4">
                                            <gofix-form-supplier
                                                    label="Supplier Name"
                                                    :contract-id="miscCreateObj.contract ? miscCreateObj.contract.id : null"
                                                    v-model="miscCreateObj.supplier">
                                            </gofix-form-supplier>
                                        </b-col>
                                    </template>
                                </b-row>
                                <b-row v-if="miscCreateObj.payee_type == 'Supplier'">
                                    <b-col md="4" v-if="miscCreateObj.is_new_supplier">
                                        <gofix-form-input label="Name" v-model="miscCreateObj.supplier_name"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field label="Address">
                                            <template slot="gofixTextField:after_label">
                                                <gofix-button class="editRight float-right" label="Edit" v-if="miscCreateObj.payee_type === 'Manual'" @click="$refs['modal-Address'].show()" noBorder fontNormal small></gofix-button>
                                            </template>
                                            {{miscCreateObj.address && miscCreateObj.address.display_address ? miscCreateObj.address.display_address : '--'}}
                                        </gofix-text-field>
                                        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-Address">
                                            <b-form class="pb-10">
                                                <gofix-form-input label="Street Number" v-model="miscCreateObj.address.street_no"></gofix-form-input>
                                                <gofix-form-input label="Street Name" v-model="miscCreateObj.address.street_name"></gofix-form-input>
                                                <gofix-form-input label="Unit no" v-model="miscCreateObj.address.unit_no"></gofix-form-input>
                                                <gofix-form-input label="Building Name" v-model="miscCreateObj.address.building_name"></gofix-form-input>
                                                <gofix-form-input label="Country" v-model="miscCreateObj.address.country" disabled></gofix-form-input>
                                                <gofix-form-input label="Postal code" v-model="miscCreateObj.address.postal_code"></gofix-form-input>
                                            </b-form>

                                            <b-button-group class="d-block text-right">
                                                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
                                            </b-button-group>
                                        </b-modal>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field label="Creditor Code" oneline>
                                            <!-- {{ miscCreateObj.supplier && miscCreateObj.supplier.creditor_code ? miscCreateObj.supplier.creditor_code : '--' }} -->
                                            {{ getCreditorCode }}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row v-if="miscCreateObj.payee_type == 'Manual'">
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Name"
                                                v-model="miscCreateObj.manual_pay_to"
                                                :options="manualPayToData"
                                                vLabel="full_name"
                                                :filterable="true"
                                                :taggable="true">
                                          <template #gofixInput:dropdown:option="option">
                                            {{option.id ? (option.id + ' - ' + option.full_name) : option.full_name}}
                                          </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field label="Address">
                                            <template slot="gofixTextField:after_label">
                                                <gofix-button class="editRight float-right" label="Edit" @click="$refs['modal-Address'].show()" noBorder fontNormal small></gofix-button>
                                            </template>
                                            {{miscCreateObj.address && miscCreateObj.address.display_address ? miscCreateObj.address.display_address : '--'}}
                                        </gofix-text-field>
                                        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-Address">
                                            <b-form class="pb-10">
                                                <gofix-form-input label="Street Number" v-model="miscCreateObj.address.street_no"></gofix-form-input>
                                                <gofix-form-input label="Street Name" v-model="miscCreateObj.address.street_name"></gofix-form-input>
                                                <gofix-form-input label="Unit no" v-model="miscCreateObj.address.unit_no"></gofix-form-input>
                                                <gofix-form-input label="Building Name" v-model="miscCreateObj.address.building_name"></gofix-form-input>
                                                <gofix-form-input label="Country" v-model="miscCreateObj.address.country" disabled></gofix-form-input>
                                                <gofix-form-input label="Postal code" v-model="miscCreateObj.address.postal_code"></gofix-form-input>
                                            </b-form>
                                            <b-button-group class="d-block text-right">
                                                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
                                            </b-button-group>
                                        </b-modal>
                                    </b-col>
                                </b-row>
                                <b-row v-if="miscCreateObj.payee_type == 'FM Employee'">
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Select FM Employee"
                                                v-model="miscCreateObj.employee"
                                                :options="optionsFMEmployee"
                                                @search="searchEmployee"
                                                :filterable="false"
                                                vLabel="name">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input label="Receipt No" v-model="miscCreateObj.receipt_no"></gofix-form-input>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-form-input label="Description" v-model="miscCreateObj.claim_description"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row >
                                    <b-col md="4">
                                        <gofix-form-input-number
                                                label="Amount Before Tax"
                                                v-model="miscCreateObj.amount"
                                                prefix="$"></gofix-form-input-number>
                                    </b-col>
                                    <b-col md="4">
                                        <b-row>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                        label="Tax Code"
                                                        v-model="miscCreateObj.tax"
                                                        :options="optionsTax"
                                                        vLabel="description"
                                                        :filterable="false"
                                                        @search="searchTaxCode">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="6">
                                                <gofix-form-input-number
                                                        label="Tax Amount"
                                                        v-model="miscCreateObj.tax_amount"
                                                        prefix="$"></gofix-form-input-number>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col md="4" align-self="center">
                                        <gofix-text-field label="Total Amount"  oneline>
                                            {{ $accounting.formatMoney($accounting.unformat(miscCreateObj.amount) + $accounting.unformat(miscCreateObj.tax_amount), { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) }}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card title="payment info">
                                <b-row class="mb-3">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Payment voucher number"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher"><RouterLink class="misc-voucher-number" :to="`/v2/payment-voucher/${miscCreateObj.payment_voucher.id}`">{{miscCreateObj.payment_voucher.pv_number}}</RouterLink></div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Payment date"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher">{{miscCreateObj.payment_voucher.pv_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}</div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Payment Amount"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher">{{miscCreateObj.payment_voucher.payment_amount | formatMoney }}</div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Payment mode"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher">{{miscCreateObj.payment_voucher.payment_mode}}</div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Cheque number"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher">{{miscCreateObj.payment_voucher.cheque_number}}</div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field classLabel="mw-190" label="Cheque Date"  oneline>
                                            <div class="info-right" v-if="miscCreateObj.payment_voucher">{{miscCreateObj.payment_voucher.cheque_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}</div>
                                            <div class="info-right" v-else>--</div>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-attachment :Item="miscCreateObj && miscCreateObj.id ? miscCreateObj : {}" :attachable_type="'misc_expenses'" title="Attachments" classCard="mb-0" classContentCard="mb-0" :isFixed="false"></gofix-attachment>
                            <!-- <gofix-card title="attachments">
                                <template slot="gofixCard:right_header">
                                    <b-button class="icon-button mr-2" @click="openModelRemoveUpload" v-if="selected.length">
                                        <div class="tooltip">Delete</div>
                                        <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                            <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                        </svg>
                                    </b-button>
                                    <b-button class="icon-button" type="button">
                                        <div @click="openModelUpload" class="tooltip">Create</div>
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                  </svg>
                                    </b-button>
                                    <b-button class="icon-button ml-2" @click="dowloadAttachments" v-if="selected.length">
                                        <div class="tooltip">Download</div>
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#999999"/>
                                        </svg>
                                    </b-button>
                                </template>
                                <b-row>
                                    <b-col md="4" v-for="(attachment) in miscCreateObj.attachments" v-bind:key="attachment.id">
                                        <b-row>
                                            <b-col md="1" class="text-center">
                                                <div class="flex-column-justify-center h-100-percent">
                                                    <b-form-checkbox :value="attachment.id" v-model="selected" class="uniform pl-15" ></b-form-checkbox>
                                                </div>
                                            </b-col>
                                            <b-col md="11">
                                                <div class="flex-column-justify-center h-100-percent attachment-section">
                                                    <div class="text-hidden-ellipsis-two-row">{{attachment.image_file_name}}</div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </gofix-card> -->
                        </b-form>
                    </template>
                    <template slot="gofixTab:related-work-item">
                        <related-work-item></related-work-item>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities  ref="itemActivities" activityType="Misc Expense" :activityId="$route.params.id"></activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer>
            <b-form class="formV2">
                <b-form-group>
                    <b-form-file ref="file-input" v-model="fileAttachment" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button
                            v-if="this.$route.params.id != 0"
                            label="SUBMIT"
                            :loading="isUpload"
                            @click="uploadAttachment" noBorder></gofix-button>
                    <gofix-button
                            v-else
                            label="SUBMIT"
                            :loading="isUpload"
                            @click="createAttachment" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to Attachments" hide-footer hide-header :centered="true" ref="modal-Remove-Attachments">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-Remove-Attachments'].hide()">No</b-button>
                <b-button class="custom-btn" @click="removeAttachments" :disabled="isRemove"><b-spinner v-if="isRemove" type="grow" small></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments-edit" id="modal-Contract-Attachments" hide-footer>
            <b-form class="formV2">
                <b-form-group>
                    <b-form-file ref="file-input" v-model="fileAttachment" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="updateAttachment" :loading="isUpload" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { generalAddressFormat } from "./../../_commonVar.js";
    const Activities = () => import("../global/Activities")
    const RelatedWorkItem = () => import("./related-work-item")
    const attachment = () => import('@/views/attachments/list')

    import moment from 'moment';
    const accounting = require('accounting');

    export default {
        name: 'misc-expenses-detail',
        components: {
            attachment,
            Activities,
            RelatedWorkItem
        },
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "related-work-item",
                        title: "Related Work Items",
                        active: false,
                        disabled: this.$route.params.id == 0
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false,
                        disabled: this.$route.params.id == 0
                    },
                ],
                treeProperty: [],
                isAction: false,
                optionsTransaction: ['Budgeted', 'Non-Budgeted'],
                optionsDepartment:  [],
                optionsPayment:     [],
                optionsFMCode:      [],
                optionsTax:         [],
                optionsContract:    [],
                optionsFMEmployee:  [],
                optionsSupplier:    [],
                optionsStatus:      ['Draft', 'Submitted', 'Approved', 'Posted' ,'Paid'],
                timeCurrent:        null,
                //payee_type_option:  ['Manual', 'FM Employee', 'Supplier'],
                payee_type_option:  ['Manual', 'Supplier'],
                manualPayToData: [],
                miscCreateObj: {
                    claim_number: null,
                    contract:     null,
                    property:     null,
                    claim_date:   null,
                    claim_transaction_type: 'Budgeted',
                    payment_method_id: null,
                    department:        null,
                    receipt_no: null,
                    payee_id:           null,
                    payee_type:         'Supplier',
                    claim_description:  null,
                    fm_code:            null,
                    payment_method:     null,
                    gl_code:            null,
                    description:        null,
                    amount:             null,
                    tax_amount:         null,
                    tax:                null,
                    status:             'Draft',
                    supplier:           null,
                    employee:           null,
                    ids_attachment:     [],
                    attachments:        [],
                    supplier_name:      null,
                    is_new_supplier:    false,
                    address : {
                        first_name:     '',
                        last_name:      '',
                        display_name:      '',
                        street_no:      '',
                        street_name:    '',
                        building_name:  '',
                        unit_no: '',
                        city: '',
                        country: 'Singapore',
                        postal_code: '',
                        display_address: ''
                    },
                    manual_pay_to: null,
                    issue_date_budget: null
                },
                tierLevel: 1,
                fileAttachment: null,
                fileName: 'Click Browse to upload file',
                isUpload: false,
                isRemove: false,
                selected: [],
                loading:{
                    properties:false,
                    employee  :false,
                    supplier  :false,
                    fmcode    :false,
                    department: false
                },
                isGetInfo: false
            }
        },
        created () {
            if(!this.$route.params.hasOwnProperty('id') || (this.$route.params.id != 0 && isNaN(this.$route.params.id))) {
                return this.$router.push(`/v2/misc-expenses`);
			}

            if(this.$route.params.id === "0"){
                this.$store.commit("MiscExpensesController/setItem", {});
                this.miscCreateObj.claim_date = moment().toDate();
                this.timeCurrent = moment().format("DD.MM.YYYY");
                this.miscCreateObj.contract = (this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) ? this.ClientContractID : null
            } else
                this.getMiscExpensesEdit();
            this.loadTax();
            this.getContract();
            this.getCOA()
            this.getPayment();
            this.loadManual();
        },
        watch: {
            "$route.params.id": function(val) {
                if(val) {
                    this.tabData[1].disabled = this.tabData[2].disabled = false;
                }
            },
            "miscCreateObj.contract": function(val, old){
                if(val && val.id) {
                    this.getSupplier({is_supplier: true, is_fm_company: false });
                    this.getFMCode();
                    this.loadRootProperty();
                    this.getDepartmentCode();
                }
            },
            "miscCreateObj.property": function(val, old){
                //if(val && val.id && this.miscCreateObj.contract && this.miscCreateObj.contract.id) {
                if(((val && val.id && this.$route.params.id == "0") || (val && val.id && old && old.id && old.id != val.id)) && this.miscCreateObj.contract && this.miscCreateObj.contract.id) {
                    let filter = {
                        client_contract_id: this.miscCreateObj.contract.id,
                        property_id: val.id,
                        is_dept_code: 1
					}
                    this.$store.dispatch("PropertyDepartmentController/getItems", { limit: 100, page: 1, filter: filter })
                    .then(data => {
                        if(data.items.length > 0 ) {
                            const item = {
                                ...data.items[0],
                                source_code: data.items[0].dept_code,
                                source_description: data.items[0].dept_description,
                                id: data.items[0].erp_mastercode_id,
                                finance_linking_id: data.items[0].id,
                            }
                            this.miscCreateObj.department = item
                        }
                    })
                }
            },
            "miscCreateObj.fm_code": function(val, old){
                if(old && val && val.id != old.id) {
                    this.miscCreateObj.gl_code = val.chart_of_account
                    this.miscCreateObj.description = val.description
                }

                if(!old && val) {
                    if(val.chart_of_account) this.miscCreateObj.gl_code = val.chart_of_account
                    if(val.description) this.miscCreateObj.description = val.description
                }
            },
            "miscCreateObj.supplier": function(val, old) {
                if(!val) {
                    this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, {
                        first_name:     '',
                        last_name:      '',
                        display_name:      '',
                        street_no:      '',
                        street_name:    '',
                        building_name:  '',
                        unit_no: '',
                        country: 'Singapore',
                        postal_code: '',
                        display_address: ''
                    })
                }

                if(old && val && old.id != val.id) {
                    this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, val.mailing_address)
                }

                if(!old && val) {
                    this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, val.mailing_address)
                }
            },
            "miscCreateObj.is_new_supplier": function(val, old) {
                if(val) {
                    this.miscCreateObj.supplier = null
                    this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, {
                        first_name:     '',
                        last_name:      '',
                        display_name:      '',
                        street_no:      '',
                        street_name:    '',
                        building_name:  '',
                        unit_no: '',
                        country: 'Singapore',
                        postal_code: '',
                        display_address: ''
                    })
                }
            },
            "miscCreateObj.amount": function(val, old){
                if(old && val) {
                    if(val.includes('$') && old.includes('$') && this.miscCreateObj.tax && this.miscCreateObj.tax.rate) {
                        this.miscCreateObj.tax_amount = this.$accounting.formatMoney((this.miscCreateObj.tax.rate) * accounting.unformat(val))
                    }
                }

            },
            "miscCreateObj.tax": function(val, old){
                if(val && (val.rate != null || val.rate != undefined)) {
    				if((old != null || (old == null && this.miscCreateObj.id !== 0)) && this.miscCreateObj.amount && accounting.unformat(this.miscCreateObj.amount) != 0) {
    						this.miscCreateObj.tax_amount = this.$accounting.formatMoney((val.rate) * accounting.unformat(this.miscCreateObj.amount))
    					}
    			}
            },
            "miscCreateObj.tax_amount": function(val, old){
                if(this.$route.params.id !== "0") {
                    if(!old || this.isGetInfo) {
                        this.miscCreateObj.tax_amount = this.miscExpenseItem.tax_amount
                    }
				}
			},
            "miscCreateObj.manual_pay_to": function(val, old){
                if(val && val.id) {
                    this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, val.address)
                }else{
                    if(typeof val == 'string' || val.full_name) {
                        let value = val.full_name || val;
                        let item = this.manualPayToData.filter(item => item.full_name == value.trim());
                        if(item.length) {
                            this.miscCreateObj.manual_pay_to = item[0];
                            return;
                        }

                        this.miscCreateObj.address = Object.assign(this.miscCreateObj.address, {
                            first_name:     '',
                            last_name:      '',
                            display_name:      '',
                            street_no:      '',
                            street_name:    '',
                            building_name:  '',
                            unit_no: '',
                            country: 'Singapore',
                            postal_code: '',
                            display_address: ''
                        })
                    }
                }
            },
            ClientContractID: function(val, old){
                if(old && val && old.id != val.id) {
                    this.miscCreateObj.contract = val;
                }

                if(!old && val) {
                    this.miscCreateObj.contract = val;
                }

            },
            fileAttachment: function(val, old) {
                this.fileName = 'Click Browse to upload file';
                if (val) {
                    this.fileName = val.name
                }
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                Loadings:  'MiscExpensesController/Loadings',
                miscExpenseItem:  'MiscExpensesController/Item',
                ClientContractID: 'ContractController/ClientContractID',
                COA: 'FmCodeController/coa',
            }),
            getCreditorCode() {
                var creditor_code = '';
                var source_description = '';
                if(this.miscCreateObj.supplier && this.miscCreateObj.supplier.vendor_linking_creditor_code) {
                    if(this.miscCreateObj.contract && this.miscCreateObj.contract.finance_company && this.miscCreateObj.contract.finance_company.company && this.miscCreateObj.contract.finance_company.company.id) {
                        const arrTmp = this.miscCreateObj.supplier.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.miscCreateObj.contract.finance_company.company.id);
                        if(arrTmp.length) {
                            creditor_code = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_code ? arrTmp[0].creditor_code.source_code : '';
                            source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                        }
                    }
                }

                if(creditor_code) return creditor_code + source_description;
                return;
            }
        },
        methods:{
            setType(type) {
                this.miscCreateObj.payee_type = type;
            },
            /*create and update*/
            save(raisePv = 0){
                if(this.$route.params.id !== "0" && this.miscExpenseItem.status !== "Draft" && this.miscExpenseItem.status !== "Submitted"){
                    return this.$alertNotification("This misc expense is included in PV. You can't edit", "danger");
                }
                if(raisePv == 1){
                    if (!this.miscCreateObj.manual_pay_to && this.miscCreateObj.payee_type == 'Manual') {
                        return this.$alertNotification("Manual Name is a required field.", "danger");
                    }
                }
                if (!this.miscCreateObj.contract) {
                    return this.$alertNotification("Contract is a required field.", "danger");
                }
                if (!this.miscCreateObj.property) {
                    return this.$alertNotification("Property is a required field.", "danger");
                }
                // if (!this.miscCreateObj.payment_method) {
                //     return this.$alertNotification("Payment is a required field.", "danger");
                // }
                if (this.miscCreateObj.claim_transaction_type == 'Non-Budgeted') {
                    if (!this.miscCreateObj.gl_code) {
                        return this.$alertNotification("GL Code is a required field.", "danger");
                    }
                } else {
                    if (!this.miscCreateObj.fm_code) {
                        return this.$alertNotification("FM Code is a required field.", "danger");
                    }
                    // if(this.miscCreateObj.contract.settings.is_required_fm_code && !this.miscCreateObj.fm_code) {
                    //     return this.$alertNotification("FM Code is a required field.", "danger");
                    // }
                    // if(this.miscCreateObj.contract.settings.is_required_gl_code && !this.miscCreateObj.gl_code) {
                    //     return this.$alertNotification("GL Code is a required field.", "danger");
                    // }
                }

                
                if(this.isAction) return;
                this.isAction = true;

                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    let request = {
                        claim_date:             moment(this.miscCreateObj.claim_date).format("YYYY-MM-DD"),
                        claim_number:           this.miscCreateObj.case_number,
                        client_contract_id:     this.miscCreateObj.contract.id,
                        claim_transaction_type: this.miscCreateObj.claim_transaction_type,
                        payment_method_id:      this.miscCreateObj.payment_method ? this.miscCreateObj.payment_method.id : null,
                        property_id:            this.miscCreateObj.property ? this.miscCreateObj.property.id : null,
                        //department:             this.miscCreateObj.department,
                        receipt_no:             this.miscCreateObj.receipt_no,
                        payee_type:             this.miscCreateObj.payee_type,
                        fm_code_id:             this.miscCreateObj.fm_code ? this.miscCreateObj.fm_code.id : null,
                        claim_description:      this.miscCreateObj.claim_description,
                        amount:                 this.$accounting.unformat(this.miscCreateObj.amount),
                        tax_amount:             this.$accounting.unformat(this.miscCreateObj.tax_amount),
                        tax_id:                 this.miscCreateObj.tax ? this.miscCreateObj.tax.id : null,
                        status:                 raisePv == 2 ? this.miscCreateObj.status : "Submitted",//raisePv == 2 -> btnSave
                        activity_action:        raisePv === 2 ? "Update ME" : (!raisePv ? "Submit" : "Submit & Raise PV"),//raisePv == 2 -> btnSave
                        ids_attachment:         this.miscCreateObj.ids_attachment,
                        is_new_supplier:        this.miscCreateObj.is_new_supplier,
                        supplier_name:          this.miscCreateObj.supplier_name,
                        //supplier_address:       this.miscCreateObj.address,
                        department_code_id:     this.miscCreateObj.department && this.miscCreateObj.department.id ? this.miscCreateObj.department.id : '',
                        gl_code_id:             this.miscCreateObj.gl_code && this.miscCreateObj.gl_code.id ? this.miscCreateObj.gl_code.id : '',
                        issue_date_budget:      this.miscCreateObj.issue_date_budget ? moment(this.miscCreateObj.issue_date_budget).format("YYYY-MM-DD") : null,
                    };


                    if(this.miscCreateObj.payee_type == 'Manual'){
                        request.payee_info = this.miscCreateObj.address
                        request.manual_pay_to = this.miscCreateObj.manual_pay_to
                    } else if (this.miscCreateObj.payee_type == 'Supplier'){
                        if(!this.miscCreateObj.is_new_supplier) {
                            request.payee_info = this.miscCreateObj.supplier ? this.miscCreateObj.supplier.id : null
                            if((this.miscCreateObj.supplier && this.miscCreateObj.supplier.mailing_address)){
                                request.address = this.miscCreateObj.address
                            } else if(this.miscCreateObj.supplier && this.miscCreateObj.supplier.mailing_address_id) {
                                request.address = this.miscCreateObj.address
                                request.address.id = this.miscCreateObj.supplier.mailing_address_id
                            }
                        }
                        else {
                            request.payee_info = this.miscCreateObj.address
                        }
                    } else if(this.miscCreateObj.payee_type == 'FM Employee'){
                        request.payee_info = this.miscCreateObj.employee.id
                    }
                    if(request.address){
                        delete request.address.full_address
                    }
                    let method    = 'createItem';
                    let keyMessage= 'adding'
                    if(this.$route.params.id != "0") {
                        if(this.miscCreateObj.address && this.miscCreateObj.address.full_address){
                            delete this.miscCreateObj.address.full_address
                        }
                        request.payee_id  = this.miscCreateObj.payee_id;
                        request.id        = this.$route.params.id;
                        method            = 'updateItem';
                        keyMessage = 'editing'
                    }
                    this.$store.dispatch(`MiscExpensesController/${method}`, request)
                    .then(async (response) => {
                        this.isAction = false
                        if(this.$refs.itemActivities) this.$refs.itemActivities.triggerReloadData();
                        if(raisePv === 1){
                            await this.raisePv(response.data.data);
                        } else {
                            this.$alertNotification(this.$notificationV2(keyMessage, 'misc_expenses'));
                            if(this.$route.params.id == "0"){
                                await this.$router.push('/v2/misc-expenses/' + response.data.data.id)
                            }
                            await this.getMiscExpensesEdit()
                        }

                        //this.$router.push(`/v2/misc-expenses`)
                    }).catch(err => {
                        this.isAction = false
                    })
                }, 300);
            },
            raisePv(data){
                let request = {
                    pv_date : moment().format('YYYY-MM-DD'),
                    status : 'Under Approval',
                    pay_to_type : data.payee_type,
                    address : data.payee_info ? data.payee_info : null,
                    client_contract_id : data.client_contract_id,
                    misc_expense_ids : [data.id],
                    from_raise  : "ME"
                }
                if(data.payee_type == 'Supplier'){
                    request.pay_to_id = data.payee_id
                }
                if(data.payee_type == 'Manual'){
                    request.manual_pay_to = data.manual_pay_to
                }
                this.$store.dispatch(`PaymentVoucherController/createPayment`, request)
                .then(async (response) => {
                    await this.$alertNotification(this.$notificationV2('adding', 'payment_voucher'));
                    this.miscCreateObj.payment_voucher = response.data.data
                    //if(this.$route.params.id == "0"){
                        //await this.$router.push('/v2/misc-expenses/' + data.id)
                        await this.$router.push('/v2/payment-voucher/' + response.data.data.id)
                    //}
                    //await this.getMiscExpensesEdit()
                })
                .catch(error => {
                    console.log(error);
                })
            },
            cancelMiscExpense(){
                let request = {
                    activity_action : "Cancel",
                    status: "Cancelled",
                    id: this.$route.params.id
                };
                this.$store.dispatch(`MiscExpensesController/updateItem`, request)
                .then(result => {
                    if(this.$refs.itemActivities) this.$refs.itemActivities.triggerReloadData();
                    this.miscCreateObj.status = result.data.data.status;
                    this.miscExpenseItem.status = result.data.data.status;
                    this.$alertNotification(this.$notificationV2('editing', 'misc_expenses'));
                }).catch(err => {
                    console.log(err);
                })
            },
            /*get info*/
            getMiscExpensesEdit() {
                this.isGetInfo = true;
                this.$store.dispatch('MiscExpensesController/getItem', {id: this.$route.params.id})
                .then(async response => {
                    let obj = await response.data.data;
                    this.timeCurrent = moment(obj.created_at).format("DD.MM.YYYY")
                    obj = Object.assign(obj, {
                        payee_type:    obj.payee_type ? obj.payee_type : this.miscCreateObj.payee_type,
                        contract:      obj.contracts,
                        property:      obj.properties,
                        claim_date:    moment(obj.claim_date).toDate(),
                        tax:           obj.tax,
                    });
                    obj.tax_amount = await this.$accounting.formatMoney(obj.tax_amount)
                    obj.amount = await this.$accounting.formatMoney(obj.amount)
                    this.miscCreateObj = Object.assign(this.miscCreateObj, obj)
                    if(obj.payee_type == 'Manual'){
                        if(this.miscCreateObj.manual_pay_to) {
                            
                            if(this.miscCreateObj.manual_pay_to.address) {
                                
                                this.miscCreateObj.manual_pay_to.address.display_address = this.miscCreateObj.payee_address ? this.miscCreateObj.payee_address : ''
                                
                                this.miscCreateObj.address =  Object.assign(this.miscCreateObj.address, this.miscCreateObj.manual_pay_to.address)
                            }
                            
                            if(this.miscCreateObj.manual_pay_to.full_name) {
                                this.miscCreateObj.manual_pay_to.full_name = this.miscCreateObj.payee_name ? this.miscCreateObj.payee_name : ''
                            }
                            
                        }
                    } else if (obj.payee_type == 'Supplier'){
                        this.miscCreateObj.supplier = Object.assign({}, this.miscCreateObj.payee_info)
                        
                        if(this.miscCreateObj.supplier.name) {
                            this.miscCreateObj.supplier.name = this.miscCreateObj.payee_name ? this.miscCreateObj.payee_name : ''
                        }
                        
                        if(this.miscCreateObj.supplier.mailing_address) {
                            this.miscCreateObj.supplier.mailing_address.display_address = this.miscCreateObj.payee_address ? this.miscCreateObj.payee_address : ''
                        }
                    } else {
                        this.miscCreateObj.employee = Object.assign({}, this.miscCreateObj.payee_info)
                    }
                    this.miscCreateObj.issue_date_budget = this.miscCreateObj.issue_date_budget ? moment(this.miscCreateObj.issue_date_budget).toDate() : null;

                    if(obj.claim_transaction_type == 'Budgeted') {
                        this.miscCreateObj.fm_code = Object.assign(this.miscCreateObj.fm_code, {
                            fm_code: this.miscCreateObj.fm_code_text ? this.miscCreateObj.fm_code_text : '',
                            description: this.miscCreateObj.fm_code_description ? this.miscCreateObj.fm_code_description : '',
                            gl_code: this.miscCreateObj.gl_code_text ? this.miscCreateObj.gl_code_text : '',
                            chart_of_account: Object.assign({}, 
                                { name: this.miscCreateObj.gl_code_description ? this.miscCreateObj.gl_code_description : ''}
                            )
                        })
                    } else {
                        this.miscCreateObj.gl_code = Object.assign(this.miscCreateObj.gl_code, {
                            gl_code: this.miscCreateObj.gl_code_text ? this.miscCreateObj.gl_code_text : '',
                            name: this.miscCreateObj.gl_code_description ? this.miscCreateObj.gl_code_description : ''
                        })
                    }
                    
                    this.isGetInfo = await false;
                })
                .catch(err => {
                    this.isGetInfo = false;
                    console.log(err);
                })
            },
            /*Contract*/
            loadTax(filter = {}, limit = 100) {
                let request = {
                    isActive: 1,
                    isNotSave: 1,
                    limit: limit,
                    filter: filter
                }
                this.$store.dispatch("TaxVersioningController/getTaxItems", request).then(data => {
                  this.optionsTax = data.items;
                });
            },
            searchTaxCode(search, loading) {
                this.taxOptions = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.loadTax({tax_code: search}, 100);
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            /*Adrees*/
            hanldeAddress() {
                this.miscCreateObj.address.display_address = generalAddressFormat(this.miscCreateObj.address)
                this.$refs['modal-Address'].hide()
            },
            /*Contract*/
            getContract(filter = null, limit = 100) {
                this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filter, limit])
                .then(response => {
                    this.optionsContract = response.data;
                })
            },
            searchContract(search, loading){
                this.optionsContract = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.getContract({contract_name: search });
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            /*Property*/
            getProperty(property_root_id, contract_id) {
                return new Promise (( resolve, reject ) => {
                    global.axios(`api/contracts/${contract_id}/tree-properties/${property_root_id}`, { method: "GET", headers: { Accept: "application/json", } })
                        .then(response => { resolve(response.data.data) }).catch(error => {});
                });
            },
            loadRootProperty(){
                this.loading.properties = true;
                global.axios(`api/contracts/${this.miscCreateObj.contract.id}/tree-properties/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                })
                    .then(result => {
                        this.treeProperty = result.data.data;
                        this.loading.properties = false;
                    })
            },
             /*Employee*/
            getEmployee(filter = null, limit = 100) {
                this.loading.employee = true;
                this.$store.dispatch("v2UserController/searchListUser", { limit: limit, page: 1, filters: filter })
                .then(response => {
                    this.optionsFMEmployee = response.data;
                    this.loading.employee = false;
                })
            },
            searchEmployee(search, loading) {
                this.taxOptions = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.getEmployee({name: name, type_user: "fm_user", contract_id: this.miscCreateObj.contract.id });
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            /*FM code*/
            getFMCode(filter = null, limit = 100) {
                let contractID = this.miscCreateObj && this.miscCreateObj.contract ? this.miscCreateObj.contract.id : null
                this.loading.fmcode = true;
                this.$store.dispatch("FmCodeController/getFmCodeItems", { limit: limit, page: 1, filter: filter, contract_id : contractID })
                .then(response => {
                    this.optionsFMCode = response.items;
                    this.loading.fmcode = false;
                })
            },
            searchFMCode(search, loading) {
                this.optionsFMCode = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.getFMCode({fm_code: search});
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            showGLCode(value){
              this.miscCreateObj.gl_code = value.gl_code
            },
            /*Department code*/
            getDepartmentCode(filter = {}, limit = 100) {
                this.loading.department = true;
                let filters = {
                    source_type: "D",
                    is_blocked: 0,
                    contract_id: this.miscCreateObj.contract.id,
                    ...filter
                };
                let params = {
                    filter: filters,
                    limit: -1,
                    sortColumn: "source_code",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.optionsDepartment = response.items;
                      this.loading.department = false;
                    })

                // this.$store.dispatch("PropertyDepartmentController/getItems", { limit: limit, page: 1, filter: filter })
                // .then(response => {
                //     this.optionsDepartment = response.items;
                //     this.loading.department = false;
                // })
            },
            searchDepartmentCode(search, loading) {
                this.optionsDepartment = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.getDepartmentCode({source_code: search});
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            getPayment(){
                let filter = {reference_type: "Payment Method"}
                let params = {filter: filter, limit: 100, isCMS: true }
                this.$store.dispatch(`MiscExpensesController/getReferences`, params)
                .then(response => {
                    this.optionsPayment = response.data.data.items;
                })
            },
            /*COA*/
            getCOA() {
                this.$store.dispatch("FmCodeController/getCOA",{limit: 100});
            },
            searchCOA(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch( 'FmCodeController/getCOA', { limit: 100, filter: { search: search } })
                    .then(response => {
                        loading(false)
                    })
                    .catch(err=>{ loading(false) })
                }, 500);
            },
            /*add file*/
            openModelUpload() {
              this.isUpload = false
              this.fileAttachment = null;
              this.$refs['modal-Import-attachments'].show()
            },
            uploadAttachment() {
                if (!this.fileAttachment) {
                    return this.$alertNotification("Please select a file", "danger");
                };
                this.isUpload = true
                this.$store.dispatch('MiscExpensesController/uploadAttachment', {
                    id: this.$route.params.id,
                    attachment: this.fileAttachment,
                }).then(result => {
                    this.$refs['modal-Import-attachments'].hide()
                    this.miscCreateObj.attachments = result.data.data.attachments
                    //this.getMiscExpensesEdit()
                    this.$alertNotification(this.$notificationV2('editing', 'attachment'));
                })
            },
            createAttachment() {
                if (!this.fileAttachment) {
                    return this.$alertNotification("Please select a file", "danger");
                };
                this.isUpload = true
                this.$store.dispatch('MiscExpensesController/createAttachment', {
                    attachment: this.fileAttachment,
                }).then(result => {
                    this.$refs['modal-Import-attachments'].hide()
                    if(result.data.data.items.length > 0) {
                        // this.miscCreateObj.ids_attachment = result.data.data.items.map( item => item.id);
                        this.miscCreateObj.ids_attachment.push(result.data.data.items[0].id)
                        this.miscCreateObj.attachments.push(result.data.data.items[0])
                    }
                    return this.$alertNotification(this.$notificationV2('adding', 'attachment'));
                })
            },
            /*remove and dowload file*/
            openModelRemoveUpload() {
                this.isRemove = false
                this.$refs['modal-Remove-Attachments'].show();
            },
            removeAttachments() {
                this.isRemove = true
                this.$store.dispatch('MiscExpensesController/removeAttachments', {
                    ids: this.selected
                })
                .then(async result => {
                    if(this.$route.params.id != 0) {
                        this.getMiscExpensesEdit()
                    } else {
                        this.miscCreateObj.attachments.forEach( (item, index) => {
                            if(this.selected.includes(item.id) ) {
                                this.miscCreateObj.attachments.splice(index, 1);
                            }
                        })
                    }
                    this.selected = [];
                    this.$refs['modal-Remove-Attachments'].hide()
                    return this.$alertNotification(this.$notificationV2('deleting', 'attachment'));
                })
            },
            dowloadAttachments() {
                let data = this.miscCreateObj.attachments
                data.map((item, key) => {
                    if (this.selected.includes(item.id)) {
                        axios({
                            url: item.url.original,
                            method: 'GET',
                            responseType: 'blob',
                            headers: {
                                'Authorization': ''
                            } // important
                        }).then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', item.image_file_name);
                            document.body.appendChild(link);
                            link.click();
                       });
                    }
                })
                return this.$alertNotification("Download Attachment Successfully!");
            },
            /*update file*/
            openModalupdateAttachment(item) {
                this.isUpload = false
                let attachment = {
                    fileName: item.image_file_name,
                    attachment_id: item.id
                }
                this.fileName = item.image_file_name
                this.attachment = JSON.parse(JSON.stringify(attachment))
                this.$refs['modal-Import-attachments-edit'].show();
            },
            updateAttachment() {
                this.isUpload = true
                if (this.fileAttachment) {
                    this.$store.dispatch('MiscExpensesController/updateAttachments', {
                        attachment: this.fileAttachment,
                        id: this.$route.params.id,
                        attachment_id: this.attachment.attachment_id
                    })
                    .then(result => {
                        this.miscCreateObj.attachments = result.data.data.attachments
                        //this.getMiscExpensesEdit()
                        this.$refs['modal-Import-attachments-edit'].hide();
                        return this.$alertNotification(this.$notificationV2('editing', 'attachment'));
                    })
                } else {
                    this.$refs['modal-Import-attachments-edit'].hide();
                }
            },
            showMoreSupplier(){
                switch (this.tierLevel) {
                    case 1:
                        this.optionsSupplier = this.optionsSupplier.concat(this.tiers.tier_2);
                        this.tierLevel = 2;
                        break;
                    case 2:
                        this.optionsSupplier = this.optionsSupplier.concat(this.tiers.tier_3);
                        this.tierLevel = 3;
                        break;
                }
            },
            disableButtonSave() {
                if( this.$route.params.id !== '0' ) {
                    if(this.miscExpenseItem && this.miscExpenseItem.payment_voucher)
                        return true;
                    return false;
                }
                return false;
            },
            getSupplier(){
                this.$store.dispatch("MiscExpensesController/getRelateSupplier",{
                    contract_id:this.miscCreateObj.contract.id,
                    filter:null
                }).then(response => {
                    this.tiers = response;
                    if(response.tier_1){
                        this.optionsSupplier = response.tier_1;
                        this.tierLevel = 1;
                    }else if(response.tier_2){
                        this.optionsSupplier = response.tier_2;
                        this.tierLevel = 2;
                    }else if(response.tier_3){
                        this.optionsSupplier = response.tier_3;
                        this.tierLevel = 3;
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            },
            /*Load manual data*/
            loadManual() {
                let filters = {
                    page: 1,
                    limit: -1
                };
                this.$store.dispatch('ManualPayToController/getItems', filters)
                    .then(response => {
                        this.manualPayToData = response.items;
                    })
                    .catch(error => {
                        console.log(error);
                        this.manualPayToData = [];
                    })

            },
        }
    }
</script>
